module.exports = __webpack_public_path__ + "static/media/focus-icon-3.c2711ad5.webp";